export default __webpack_public_path__ + "static/media/user-icon.ca17e275.svg";